import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AddOutputForm } from '../../components/AddOutputForm';
import { allowedConnectOptions } from '../../constants/common';

const connectOutputSchema = z
  .object({
    provider: z.enum(allowedConnectOptions).catch('custom'),
  })
  .partial()
  .optional()
  .default({
    provider: 'custom',
  });

export const Route = createFileRoute('/_authenticated/add-output/')({
  component: AddOutputPage,
  validateSearch: connectOutputSchema.parse,
});

function AddOutputPage() {
  const { provider } = Route.useSearch();
  const { authContextProvider, serviceEnvironment } = Route.useRouteContext();

  return (
    <AddOutputForm
      authContextProvider={authContextProvider}
      serviceEnvironment={serviceEnvironment}
      defaultValue={{
        provider: provider || 'custom',
      }}
    />
  );
}
